// extracted by mini-css-extract-plugin
export default {"Title":"CardHeadband_Title__95Ztd","SubHeader":"CardHeadband_SubHeader__4EGEp","Body":"CardHeadband_Body__OUdMl"};